function sendPostMessage(element, postMessageData, targetOrigin) {
  if (element) {
    element.postMessage(JSON.stringify(postMessageData), targetOrigin);
  }
}

export default sendPostMessage;
